export default __webpack_public_path__ + "static/media/result_1.a8b66109.jpg";